import React from 'react';

import { Styled } from './styles';

const Section = ({ children, ...props }) => <Styled {...props}>{children}</Styled>;

export default Section;
